import React from "react";
import { MultiprofissionalStoreProvider } from "../../../context/MultiprofissionalContext";
import MultiprofissionalSteps from "./MultiprofissionalSteps";

export default function Multiprofissional() {

    return (
        <MultiprofissionalStoreProvider>
            <MultiprofissionalSteps />
        </MultiprofissionalStoreProvider>
    )

}